import { Slot, SlotSearchParams, GetSlotsResponse } from '../../Model/Slot';
import { SlotRepository } from '../Repositories/SlotRepository';
import { User } from '../../../User/Model/User';
import { calcRemaining, parseCalendarDate, startOfTodayLocal } from './Utils/DateUtil';

export class GetSlotsUseCase {
  constructor(private repo: SlotRepository) {}

  execute(current: User | null, params?: SlotSearchParams): Promise<GetSlotsResponse> {
    // 정렬 옵션 정규화 및 기본값 설정
    const allowedOrderBy = new Set(['registered', 'start_date', 'end_date']);
    const allowedOrderDir = new Set(['asc', 'desc']);

    const normalizedOrderBy = params?.order_by && allowedOrderBy.has(params.order_by)
      ? params.order_by
      : (params?.order_by === undefined ? 'registered' : undefined);

    const normalizedOrderDir = params?.order_dir && allowedOrderDir.has(params.order_dir)
      ? params.order_dir
      : (params?.order_dir === undefined ? 'desc' : undefined);

    // SELLER 권한인 경우 user 파라미터 추가, 정렬 반영
    const searchParams: SlotSearchParams = {
      ...params,
      ...(normalizedOrderBy ? { order_by: normalizedOrderBy } : {}),
      ...(normalizedOrderDir ? { order_dir: normalizedOrderDir } : {}),
      ...(current && current.grade === 'SELLER' ? { sellerId: current.id } : {})
    };

    return this.repo.getSlots(searchParams).then((response) => {
      // remaining_days와 status 계산
      const processedSlots = response.slots.map((s) => {
        const remaining_days = calcRemaining(s.end_date);
        const today = startOfTodayLocal();
        const endDate = parseCalendarDate(s.end_date);
        if (!endDate) {
          return { ...s, remaining_days, status: s.status } as Slot;
        }

        // 종료일이 오늘(로컬 캘린더) 이전인지 확인 — YYYY-MM-DD는 로컬 자정 기준
        const isExpired = endDate.getTime() < today.getTime();
        const isToday = endDate.getTime() === today.getTime();
        
        // 상태 결정 로직
        let status = s.status;
        if (s.status === "정상" && isExpired && !isToday) {
          status = "종료";
        } else if (s.status === "연장" && isExpired && !isToday) {
          status = "종료";
        }
        
        return {
          ...s,
          remaining_days,
          status,
        } as Slot;
      });

      return {
        ...response,
        slots: processedSlots
      };
    });
  }
}
